import React, { useState } from "react";
import { logo } from "../../assets/img";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import { isValidEmail } from "../redux/api/Constants";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState(false);
  const [loading, setLoading] = useState(false);

  const login = () => {
    const regEx = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

    if (!email) {
      setErrors("Email is required");
      toast.error("Email is required");
      return;
    }

    if (!regEx.test(email)) {
      setErrors("Enter Valid Email (lowercase only)");
      toast.error("Enter Valid Email (lowercase only)");
      return;
    }

    setErrors(false);
    setLoading(true);

    let formdata = new FormData();
    formdata.append("email", email);

    post(URLS.FORGOT_PASSWORD, formdata)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message);
          setErrors(false);
          setEmail("");
        }
        //  else {
        //   toast.error(res?.message || "Something went wrong");
        // }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Server error, please try again later");
        console.log("err", err);
      });
  };


  return (
    <div className="login-bg">
      <div className="login-left"> </div>
      <div className="login-right">
        <img src={logo} className="logo" alt="" />
        <h2 className="mt-4 f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-26 fs-xxl-28 white">
          Forgot Password
        </h2>
        <div className="text-start">
          <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 white">
            Email
          </p>
          <div className="login-input mt-2">
            <MailOutlineRoundedIcon className="emial-icon" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
            />
          </div>
          {errors && <p className="err">{errors}</p>}
        </div>

        <button onClick={login} className="login-btn f4">
          Submit
        </button>
        <p
          onClick={() => navigate("/")}
          className="mt-5 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 white pointer text-start"
        >
          Return to Login
        </p>
      </div>
      {loading && <Loader />}
    </div>
  );
};
export default ForgotPassword;
